(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-team"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.team-section__arrow').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var slider = document.getElementById(this.dataset.slider);
        if (!slider) return;
        var member = slider.querySelector('.team-section__member');
        if (!member) return;
        var scrollAmount = member.offsetWidth + 24;
        if (this.dataset.direction === 'prev') scrollAmount = -scrollAmount;
        slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    });

    document.querySelectorAll('.team-section__slider').forEach(function(slider) {
      var wrapper = slider.closest('.team-section__slider-wrapper');
      if (!wrapper) return;
      var prevBtn = wrapper.querySelector('.team-section__arrow--prev');
      var nextBtn = wrapper.querySelector('.team-section__arrow--next');
      if (!prevBtn || !nextBtn) return;

      function updateArrows() {
        prevBtn.style.display = slider.scrollLeft > 5 ? '' : 'none';
        nextBtn.style.display = slider.scrollLeft + slider.clientWidth < slider.scrollWidth - 5 ? '' : 'none';
      }

      slider.addEventListener('scroll', updateArrows);
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
